<template>
  <div class="sidebar">
    <el-scrollbar
      class="sidebar__scrollbar"
      wrap-class="sidebar__scrollbar--wrapper">
      <Menu />
    </el-scrollbar>
  </div>
</template>

<script>
import Menu from '@/components/layout/Menu.vue';

export default {
  name: 'sidebar',
  components: {
    Menu,
  },
};
</script>

<style lang="scss">

.sidebar {
  display: none;
  @include breakpoint(desktop) {
    padding-top: 60px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    width: var(--nxt-left-menu-size);
    background-color: var(--nxt-color-light-grey);
    height: 100%;
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 49;
  }
  &__scrollbar {
    height: 100%;
    overflow-x: hidden;
    &--wrapper {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      .el-scrollbar__view {
        width: var(--nxt-left-menu-size);
      }
    }
  }
}
</style>
